import React from 'react';
import LinkedInIcon from '../../logos/linkedin.png'
import akshayImage from '../../logos/linkedin_profile.jpeg'; // Make sure to add this SVG to your assets folder

const Founder = () => {
  return (
    <section className="founder">
      <div className="founder-content">
      <h2>Meet Our Team</h2>
        <div className="founder-info">
          <img src={akshayImage} alt="Akshay" className="founder-image" />
          <div className="founder-text">
            <div className="founder-name-social">
              <h3>Akshay Chintalapati</h3>
              <a href="https://www.linkedin.com/in/akshaych98/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <img src={LinkedInIcon} alt="LinkedIn" />
              </a>
            </div>
            <div class='founder-title'>Founder</div>
            <p>Akshay brings experience working with installers and service teams at Tesla, SunPower, and Generac. At SunPower and Generac, he led the development of commissioning software for solar and storage installers.</p>
            <p>While at Tesla, he worked to ensure the fleet of the residential solar and storage performed optimally, consistently achieving top performance in case resolutions and supporting field teams.</p>
            {/* <p>Across these experiences, Akshay identified a common challenge: lost productivity for companies and installing teams because technical support was vastly outnumbered by the number of issues. This led him to found Dysun, where he's developing AI-powered solutions to address this industry-wide issue and build the best support experience for customers.</p> */}
            <p>Akshay also holds a degree from Cornell University where he specialized in Energy Economics and Engineering.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;